export default function getAllFeatureFlags(context) {
    const { featureFlags: _featureFlags, session: { allFeatureFlags } = {} } = context;
    return [].concat(_featureFlags).concat(allFeatureFlags);
}
